module.exports = "/_next/static/images/b3644f77eca6a75c666039add01ba6d6-offer.png";